<template>
  <div ref="colorex"></div>
</template>

<script>
import colorex from "../../node_modules/colorex/src/colorex.js";

export default {
  props: ["color"],
  mounted: function () {
    let config = {
      picker: this.$refs.colorex,
      color: this.color,
      pixelize: { gradient: 10 },
      onChange: (result) => {
        this.$emit('changed', result.color);
      },
    };

    this.colorpicker = new colorex(config);
  },
  data() {
    return {
      colorpicker: undefined,
    };
  },
  watch: {
    color(value) {
      this.colorpicker.color = value;
    },
  },
};
</script>